var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBrandDirectory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Brand Directory") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-Menu/Showroom",
    transform: "translate(-48.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brand-Directory",
    transform: "translate(48.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CDD4DA",
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 107
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-3)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(76.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(76.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-6)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(114.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-7)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(114.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Icon/Person/M/White-Default",
    filter: "url(#filter-8)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209139,11 16,9.209139 16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 C8,9.209139 9.790861,11 12,11 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C8.13400675,13 5,16.1340068 5,20 C5,20.5522847 5.44771525,21 6,21 C6.55228475,21 7,20.5522847 7,20 C7,17.2385763 9.23857625,15 12,15 C14.7614237,15 17,17.2385763 17,20 C17,20.5522847 17.4477153,21 18,21 C18.5522847,21 19,20.5522847 19,20 C19,16.1340068 15.8659932,13 12,13 L12,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrandDirectory);
export default __webpack_public_path__ + "static/media/icon_brand_directory.39f7a98b.svg";
export { ForwardRef as ReactComponent };